import {
  DELETE_QUESTIONNAIRE_LIST,
  DELETE_QUESTIONNAIRE_LIST_SUCCESS,
  DELETE_QUESTIONNAIRE_LIST_FAILURE,
} from 'store/questionnaireDelete/questionnaireDeleteAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const deleteQuestionnairListReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_QUESTIONNAIRE_LIST:
      return { ...state, loading: true };
    case DELETE_QUESTIONNAIRE_LIST_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case DELETE_QUESTIONNAIRE_LIST_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default deleteQuestionnairListReducer;
